import ProductModel from 'coreClasses/product/ProductModel';
import VariantModel from 'coreClasses/product/VariantModel';
import {EAddToCartType} from 'coreStore/data/ui/types';

import {IButtonProps} from 'brandComponents/Button/IButton';

export enum AddToCartButtonMode {
	ADD_TO_CART = 'addToCart',
	BUY_NOW = 'buyNow',
	PREORDER_NOW = 'preOrderNow',
}
export interface IAddToCartButtonProps {
	classNames?: string;
	variationGroupId?: string;
	product: ProductModel | VariantModel;
	onSizeSelect?: (pid: string) => void;
	onClick: (buttonType: EAddToCartType) => void;
	mode: AddToCartButtonMode;
	label?: string;
	variant?: IButtonProps['variant'];
	disabled?: boolean;
	/** Add running: spinner, button disabled. */
	loading?: boolean;
}
